<template>
    <div class="content-wrap">
    </div>
</template>
<script>

export default {
    name: "Signout",
    created() {
        this.$store
            .dispatch("signout", { })
            .then(() => this.$router.push('/'));
    },
    data() {
        return {};
    },
};
</script>
<style  scoped>
.content-wrap {
    min-width: 100%;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/Signout.vue